export default "__VITE_ASSET__Bpmg2vVi__"